module.exports = __webpack_public_path__ + "img/alter-ego-hero_jp.d74d53f.png";